"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("../../shared/services/restservice");
const http_1 = require("@angular/common/http");
class DeviceService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.suspendurl = '/rest-api/account/sub/action/v1/suspend';
        this.transferurl = '/rest-api/account/sub/v1/transfer';
        this.restoreurl = '/rest-api/account/sub/action/v1/restore';
        this.activatelineUrl = '/rest-api/account/activation/pending/v1/details';
        this.transactionHistoryUrl = '/rest-api/account/sub/installment/v1/';
        this.installmentAgreementUrl = '/rest-api/account/sub/installment/v1/agreementLocation/';
        this.installmentDetailUrl = '/rest-api/account/sub/installment/v1/details/';
        this.validateEsnUrl = '/rest-api/account/sub/coam/v1/esn/validation';
        this.validateUiccUrl = '/rest-api/account/sub/coam/v1/submitCOAMOrder';
        this.validateEIDUrl = '/rest-services/web-wirelesscart-services/v1/validateEid/';
        this.swapDeviceUrl = '/rest-api/account/sub/coam/v1/swapDevices';
        this.submitAuthorizerUrl = '/rest-api/account/sub/sharedPlan/v1/authorizer/changeAuthorizer';
        this.genericContentInstructionalChangeAuth = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=genericInstructionalChangeAuth';
        this.getGenericInstructionalChangeAuthNoteUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=genericInstructionalChangeAuthNote';
        this.getGenericPromoMessageNotificationUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=genericPlanDiscountMessageMMA';
        this.getMdnUrl = '/rest-api/account/sub/sharedPlan/v1/authorizer/getEligibleLines';
        this.dppEarlyPaymentUrl = '/rest-api/account/sub/installment/v1/payEarly/';
        this.pairedDeviceHistoryUrl = '/rest-api/account/v1/devicepairinghistory/';
        this.insuranceUrl = '/rest-api/account/insurance/v1/details';
        this.removeInsuranceUrl = '/rest-api/order/v1/addFeature';
        this.genericContentMessageDisplayUrl = '/rest/model/cellularsouth/content/ContentRepositoryActor?id=';
        this.bbdeviceUpgradeUrl = '/rest-api/account/sub/device/upgrade/v1/business';
        this.bbBulkSuspendDataUrl = '/rest-api/account/sub/action/v1/usage/suspend';
        this.bbBulkUnSuspendDataUrl = '/rest-api/account/sub/action/v1/usage/unsuspend';
        this.getPooledDataUrl = '/rest-api/account/v1/pooledData/feature/';
        this.changePooledDataUrl = '/rest-api/account/v1/submit/pooledData';
        this.removePooledDataUrl = '/rest-api/account/v1/submit/removePooledData';
        this.contractDetailUrl = '/rest-api/account/v1/business/contractDetails/';
        this.deactivateLineUrl = '/rest-api/account/v1/subscriptions/';
        this.updateSubscriptionUrl = '/rest-services/web-wirelessaccount-services/v1/account/subscriptions';
        // CIP:224 - validate from account transfer url
        this.validateFromAccountUrl = '/rest-api/account/sub/v1/transfer/validateFromAccount';
        // CIP:209 - get Data passes url
        this.getDataPassesUrl = '/rest-api/account/sub/v1/datapasses?subId=';
        this.validateBillToAccountUrl = '/rest-api/account/sub/v1/datapass/bta-eligible?subId=';
        this.getBTADetailsUrl = '/global/checkoutController.jsp?action=getBillToAccountDetails';
        this.submitDataPassUrl = '/rest-api/account/sub/v1/datapass/submit';
        // CIP-411
        this.verifyDiagnosticsUrl = '/rest-services/web-wirelessaccount-services/v1/account/subscriptions/provisioning-status?msisdn=';
        this.fixAllDiagnosticsUrl = '/rest-services/web-wirelessaccount-services/v1/account/subscriptions/provision-subscription?subscriptionId=';
        this.diagnosticsHistoryUrl = '/rest-services/web-wirelessaccount-services/v1/account/diagnostic-history/';
    }
    suspendLine(subscrptionId) {
        const inputArgs = new http_1.HttpParams().set('subId', subscrptionId);
        return this.post(this.suspendurl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getCartDetails() {
        return this.get('/global/ajax_json_controller.jsp?action=getUpgradedDevices').pipe(operators_1.map((data) => data));
    }
    restoreLine(subscrptionId) {
        const inputArgs = new http_1.HttpParams().set('subId', subscrptionId);
        return this.post(this.restoreurl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getActivatelineDetails() {
        return this.get(this.activatelineUrl).pipe(operators_1.map((data) => data));
    }
    getInstallmentTransactionHistory(subscrptionId) {
        return this.get(this.transactionHistoryUrl + subscrptionId + '/history').pipe(operators_1.map((data) => data));
    }
    getSignedInstallmentAgreement(subscrptionId) {
        return this.get(this.installmentAgreementUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    getInstallmentDetail(subscrptionId) {
        return this.get(this.installmentDetailUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    getContractDetails(subscrptionId) {
        return this.get(this.contractDetailUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    validate(pin) {
        const inputArgs = new http_1.HttpParams().set('esn', pin.esnID).set('subId', pin.currentSubId);
        return this.post(this.validateEsnUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    validateSim(value) {
        let inputArgs;
        if (value.eid === 'null') {
            inputArgs = new http_1.HttpParams().set('uiccID', value.uiccID).set('subId', value.currentSubId).
                set('isNewUiccRequested', value.isNewUiccRequested).set('isCoamable', value.coamValue).set('isEsimDevice', value.isEsimCapable);
        }
        else {
            inputArgs = new http_1.HttpParams().set('uiccID', value.uiccID).set('subId', value.currentSubId).
                set('isNewUiccRequested', value.isNewUiccRequested).set('isCoamable', value.coamValue).set('isEsimDevice', value.isEsimCapable).set('eid', value.eid);
        }
        return this.post(this.validateUiccUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    validateCOAMeId(value) {
        return this.get(this.validateEIDUrl + value.eid).pipe(operators_1.map((data) => data));
    }
    validateSwapDevice() {
        // const inputArgs = new HttpParams().set('uiccID', value.uiccID)
        // .set('isNewUiccRequested', value.isNewUiccRequested).set('isCoamable', value.coamValue);
        return this.post(this.swapDeviceUrl, '').pipe(operators_1.map((data) => data));
    }
    // WIPP-174 - getting 12 month promotion notification generic content
    getGenericPromoMessageNotification() {
        return this.get(this.getGenericPromoMessageNotificationUrl).pipe(operators_1.map((data) => data));
    }
    getMdnDetails() {
        return this.get(this.getMdnUrl).pipe(operators_1.map((data) => data));
    }
    submitAuthorizedDataManager(currentAuthSubId, newAuthSubId) {
        const inputArgs = new http_1.HttpParams().set('currentAuthSubId', currentAuthSubId).set('newAuthSubId', newAuthSubId);
        return this.post(this.submitAuthorizerUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    dppEaryPayment(payment) {
        let inputArgs;
        if (payment.payamount === 'fullpayment') {
            this.payFull = true;
            this.payDifferent = false;
            payment.differentPay = 0;
            inputArgs = new http_1.HttpParams().set('fullAmount', payment.fullamount).set('diffAmount', payment.differentPay).set('subId', payment.subId).
                set('payFull', this.payFull).set('payDifferent', this.payDifferent);
        }
        else {
            this.payFull = false;
            this.payDifferent = true;
            inputArgs = new http_1.HttpParams().set('fullAmount', payment.fullamount).set('diffAmount', payment.differentPay).
                set('subId', payment.subId).set('payFull', this.payFull).set('payDifferent', this.payDifferent);
        }
        return this.post(this.dppEarlyPaymentUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    getPairedDeviceHistory(subId) {
        return this.get(this.pairedDeviceHistoryUrl + subId).pipe(operators_1.map((data) => data));
    }
    getInsurance(subId) {
        return this.get(this.insuranceUrl + '/' + subId).pipe(operators_1.map((data) => data));
    }
    removeInsurance(feature, subId, isPrepaidRBTRemoval) {
        const inputArgs = new http_1.HttpParams().set('featureToRemove', feature).set('subId', subId).set('isPrepaidRBTRemoval', isPrepaidRBTRemoval);
        return this.post(this.removeInsuranceUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    genericContentMessageDisplay(genericContentId) {
        const genericContentMessageDisplayUrl = this.genericContentMessageDisplayUrl + genericContentId;
        return this.get(genericContentMessageDisplayUrl).pipe(operators_1.map((data) => data));
    }
    transferLine(formData, accountType, subId) {
        const inputArgs = {
            'mdn': formData.MDN,
            'ssn': formData.SSN,
            'pin': formData.PIN,
            'transferType': formData.radioGrp,
            accountType,
            subId
        };
        return this.post(this.transferurl, inputArgs, true).pipe(operators_1.map((data) => data));
    }
    deviceUpgrade(subscrptionId) {
        return this.post(this.bbdeviceUpgradeUrl + subscrptionId).pipe(operators_1.map((data) => data));
    }
    // B2B bulk upgrade API
    b2bBulkDeviceUpgrade(subscrptionList) {
        const inputArgs = new http_1.HttpParams().set('subIds', subscrptionList);
        return this.post(this.bbdeviceUpgradeUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    // B2B bulk Suspend data API
    b2bBulkSuspendData(subscrptionList) {
        const inputArgs = new http_1.HttpParams().set('subId', subscrptionList);
        return this.post(this.bbBulkSuspendDataUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    b2bBulkUnSuspendData(subscrptionList) {
        const inputArgs = new http_1.HttpParams().set('subId', subscrptionList);
        return this.post(this.bbBulkUnSuspendDataUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    pooledDataInfo(subId) {
        return this.get(this.getPooledDataUrl + subId).pipe(operators_1.map((data) => data));
    }
    submitPooledDataChange(content) {
        return this.post(this.changePooledDataUrl, content, true).pipe(operators_1.map((data) => data));
    }
    removePooledDataBucket(content) {
        return this.post(this.removePooledDataUrl, content, true).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP:224 - Check for the transfer eligibility
    */
    validateFromAccount(subscriptionId) {
        const inputArgs = new http_1.HttpParams().set('subscriptionId', subscriptionId);
        return this.post(this.validateFromAccountUrl, inputArgs.toString()).pipe(operators_1.map((data) => data));
    }
    /**
     * WEBI-6867 - Deactivate line
    */
    deactivateLine(subscrptionId) {
        const url = this.deactivateLineUrl + subscrptionId + '/deactivation';
        return this.post(url).pipe(operators_1.map((data) => data));
    }
    /* CIP:209 - get data passes
    *
    */
    getAllDataPasses(subId) {
        return this.get(this.getDataPassesUrl + subId).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP:209 - validate account for BTA eligibility
     */
    validateBillToAccount(subId, offerName, amount) {
        return this.get(this.validateBillToAccountUrl + subId + '&offerName=' + offerName + '&amount=' + amount).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP:209 - validate account for BTA eligibility
     */
    getBTADetails() {
        return this.get(this.getBTADetailsUrl).pipe(operators_1.map((data) => data));
    }
    /* CIP:209 - submit data pass order
    *
    */
    submitDataPassOrder(orderDetails) {
        return this.post(this.submitDataPassUrl, orderDetails, true).pipe(operators_1.map((data) => data));
    }
    /* WEBI-8420 update subscription information
    *
    */
    updateSubscription(updateSub) {
        return this.put(this.updateSubscriptionUrl, updateSub, true).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP-411 - verify Diagnostics
     * @param mdn
     * @returns
     */
    verifyDiagnostics(mdn) {
        return this.post(this.verifyDiagnosticsUrl + mdn).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP-411 - fix all
     * @returns
     */
    fixAllDiagnostics(subId) {
        return this.post(this.fixAllDiagnosticsUrl + subId).pipe(operators_1.map((data) => data));
    }
    /**
     * CIP-411 - description
     * @returns
     */
    diagnosticsHistory(diagnosisHistorySteps) {
        return this.post(this.diagnosticsHistoryUrl, diagnosisHistorySteps, true).pipe(operators_1.map((data) => data));
    }
}
exports.DeviceService = DeviceService;
//# sourceMappingURL=device.service.js.map